'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { useCallback, useId, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { trpc } from '@/lib/trpc/client';
import { cn } from '@/lib/utils';
interface NewsletterSignupProperties {
  className?: string;
  /** Visual treatment for the signup box. Defaults to `card`. */
  variant?: 'card' | 'inline';
}
export function NewsletterSignup(t0) {
  const $ = _c(24);
  const {
    variant: t1,
    className
  } = t0;
  const variant = t1 === undefined ? "card" : t1;
  const [email, setEmail] = useState("");
  const inputId = useId();
  const subscribeMutation = trpc.utilities.subscribeNewsletter.useMutation();
  let t2;
  if ($[0] !== subscribeMutation) {
    t2 = () => {
      if (subscribeMutation.isError || subscribeMutation.isSuccess) {
        subscribeMutation.reset();
      }
    };
    $[0] = subscribeMutation;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const resetOnChange = t2;
  let t3;
  if ($[2] !== email || $[3] !== subscribeMutation) {
    t3 = event => {
      event.preventDefault();
      if (!email) {
        return;
      }
      subscribeMutation.mutateAsync({
        email
      }).catch(_temp);
    };
    $[2] = email;
    $[3] = subscribeMutation;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const onSubmit = t3;
  const showHeading = variant === "card";
  const isSubmitting = subscribeMutation.isPending;
  const isSubmitted = subscribeMutation.isSuccess;
  const isError = subscribeMutation.isError;
  const errorMessage = subscribeMutation.error instanceof Error ? subscribeMutation.error.message : "Something went wrong. Please try again.";
  const t4 = variant === "card" ? "rounded-xl border border-border/40 bg-card/70 backdrop-blur-md p-4 sm:p-5 shadow-sm" : "max-w-md md:max-w-sm";
  let t5;
  if ($[5] !== className || $[6] !== t4) {
    t5 = cn("w-full", t4, className);
    $[5] = className;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== email || $[9] !== inputId || $[10] !== isSubmitted || $[11] !== isSubmitting || $[12] !== onSubmit || $[13] !== resetOnChange || $[14] !== showHeading || $[15] !== variant) {
    t6 = isSubmitted ? <div className="text-center"><h3 className="text-base font-semibold text-foreground mb-1">Almost there…</h3><p className="text-sm text-muted-foreground">We just sent a confirmation email{email ? ` to ${email}` : ""}. Please click the link to finish subscribing.</p></div> : <>{showHeading && <><h3 className="mb-1 text-center text-base font-semibold text-foreground">Get product updates</h3><p className="mb-3 text-center text-xs text-muted-foreground">Occasional emails about new features. No spam, unsubscribe anytime.</p></>}<form onSubmit={onSubmit} className={cn("flex w-full flex-col gap-3", variant === "card" ? "sm:flex-row" : "sm:flex-row sm:items-center")}><label htmlFor={inputId} className="sr-only">Email address</label><div className="flex-1"><Input id={inputId} name="email" type="email" required={true} autoComplete="email" placeholder="you@example.com" aria-label="Email address" value={email} onChange={e => {
            setEmail(e.target.value);
            resetOnChange();
          }} disabled={isSubmitting} /></div><div className="sm:w-auto"><Button type="submit" className="w-full sm:w-auto" disabled={isSubmitting}>{isSubmitting ? "Submitting\u2026" : "Subscribe"}</Button></div></form></>;
    $[8] = email;
    $[9] = inputId;
    $[10] = isSubmitted;
    $[11] = isSubmitting;
    $[12] = onSubmit;
    $[13] = resetOnChange;
    $[14] = showHeading;
    $[15] = variant;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== errorMessage || $[18] !== isError) {
    t7 = isError && <p className="mt-2 text-center text-xs text-destructive" role="alert">{errorMessage || "Something went wrong. Please try again or subscribe at buttondown.com/steipete."}</p>;
    $[17] = errorMessage;
    $[18] = isError;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
    t8 = <div className={t5}>{t6}{t7}</div>;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
}
function _temp(error) {
  console.error("Newsletter signup failed", error);
}